import { Illustration, LoadingSpinner, mergeSxProps, Text } from "@clipboard-health/ui-components";
import { Box, Stack, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { Button } from "@src/appV2/redesign/components/Button";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { getSafeAreaPaddings } from "@src/appV2/redesign/utils/getSafeAreaPaddings";

export interface StripeAccountVerifyingPageContentProps {
  isReturnToStripeLoading: boolean;
  onExploreTheAppClick: () => void;
  onReturnToStripeClick: () => void;
  sx?: SxProps<Theme>;
}

export function StripeAccountVerifyingPageContent(props: StripeAccountVerifyingPageContentProps) {
  const { isReturnToStripeLoading, onExploreTheAppClick, onReturnToStripeClick, sx } = props;

  return (
    <Stack
      data-testid="stripe-account-verifying-page-content-container"
      sx={mergeSxProps(
        (theme) => ({
          flex: 1,
          overflow: "hidden",
          paddingX: theme.spacing(5),
          ...getSafeAreaPaddings({ bottom: true, fallbackBottom: theme.spacing(5) }),
        }),
        sx
      )}
    >
      <Stack spacing={12} sx={(theme) => ({ alignItems: "center", marginTop: theme.spacing(8) })}>
        <Text variant="h3" sx={{ textAlign: "center" }}>
          Stripe is verifying your account
        </Text>
        <Illustration type="hourglass-gray" />
        <Text variant="body1" sx={{ textAlign: "center" }}>
          This typically takes a few minutes. Feel free to explore the app while you wait.
        </Text>
      </Stack>
      <Box sx={{ flex: 1 }} />
      <Stack spacing={5} sx={{ alignItems: "center" }}>
        <Button fullWidth onClick={onExploreTheAppClick}>
          Explore the app
        </Button>
        {isReturnToStripeLoading ? (
          <LoadingSpinner size="small" />
        ) : (
          <TextButton underline onClick={onReturnToStripeClick}>
            Return to Stripe
          </TextButton>
        )}
      </Stack>
    </Stack>
  );
}
